"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GeneralError;
// eslint-disable-next-line no-unused-vars
function GeneralError(code, message) {
  var instance = new Error(message);
  instance.message = message;
  instance.code = code;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, GeneralError);
  }
  return instance;
}
GeneralError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
if (Object.setPrototypeOf) {
  Object.setPrototypeOf(GeneralError, Error);
} else {
  GeneralError.__proto__ = Error;
}